# frozen_string_literal: true

module Engine
  module Game
    module G1893
    end
  end
end
